/* global axios */

import ApiClient from '../ApiClient';

class WooCommerceAPI extends ApiClient {
  constructor() {
    super('integrations/woocommerce', { accountScoped: true });
  }

  connect({ storeUrl, consumerKey, consumerSecret }) {
    return axios.post(`${this.url}/connect`, {
      store_url: storeUrl,
      consumer_key: consumerKey,
      consumer_secret: consumerSecret,
    });
  }

  getOrders(contactId) {
    return axios.get(`${this.url}/orders`, {
      params: { contact_id: contactId },
    });
  }
}

export default new WooCommerceAPI();
